/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
// eslint-disable-next-line import/no-extraneous-dependencies
// import InfiniteScroll from 'react-infinite-scroll-component';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Col, Input, message as toaster } from 'antd';
import { Box, Button, Flex, Text } from 'atoms';
import { getapprovalList } from 'store/approvalSlice';
import { SVG } from 'utils';
import { getSignedUrl } from 'store/commonSlice';
import { formatApprovalDate, formatApprovalTime } from 'utils/approvalDateTime';

export default function RejectedTrips() {
	// const MainBox = styled(Box)`
	// 	padding: 16px;
	// 	height: 100px;
	// 	gap: 5rem;
	// `;
	const dispatch = useDispatch();
	const [DataSource, SetDataSource] = useState([]);
	const [total_count, SetTotalCount] = useState(0);
	const [limit, SetLimit] = useState(10);
	useEffect(() => {
		console.log('sdkj');
		dispatch(getapprovalList({ limit, trip_approval_status: 3 })).then((res) => {
			console.log(res);
			SetDataSource(res?.rows);
			SetTotalCount(res?.count);
		});
	}, [dispatch, limit]);

	const fetchMoreData = () => {
		const total_counts = total_count;
		const DSDataaSource = DataSource.length;
		console.log(total_counts, DSDataaSource);
		if (DSDataaSource < total_counts) {
			SetLimit(limit + 10);
			console.log(limit);
			console.log(limit);
			apiFunc();
		} else {
			toaster.error(`End of the page`);
		}
	};

	useEffect(() => {
		console.log(limit);
		console.log(DataSource);
	}, [limit, DataSource]);

	const apiFunc = () => {
		console.log(limit);
		dispatch(getapprovalList({ limit })).then((resq) => {
			console.log(resq);
			SetDataSource(resq?.rows);
			SetTotalCount(resq?.count);
		});
	};

	const cardHeader = {
		fontSize: '12px',
		color: '#888383',
		marginBottom: '5px',
	};
	const cardValue = {
		fontSize: '16px',
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		maxWidth: '98px',
		overflowWrap: 'anywhere',
	};

	const cardValueData = {
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		fontSize: '12px',
	};

	const wid5 = {
		marginRight: '7px',
	};

	const loadMore = {
		float: 'right',
		paddingTop: '8px',
		marginTop: '5px',
	};

	const tripID = {
		color: '#1cbdf6',
		fontWeight: '800',
	};

	const DateFormat = 'DD-MM-YYYY';
	const TIME_FORMAT = 'hh:mm a';

	function getLocalDate(date) {
		return formatApprovalDate(date, DateFormat);
	}

	function getLocalTime(time) {
		return formatApprovalTime(time, TIME_FORMAT);
	}

	const padding35 = {
		padding: '5px 10px',
		width: '130px',
	};
	const padding135 = {
		padding: '5px 10px',
		width: '185px',
	};
	const vdgicon = {
		margin: '30px 5px',
	};

	const getTripCard = (item, index) => (
		<Box className="apporval-card" key={index}>
			<Flex>
				<Box style={vdgicon}>
					<Box>
						<SVG.AdhocAppprvalIcons width="26px" />
					</Box>
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Project Location </Col>
					<Col style={cardValue}> {item?.project_location_code} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> City</Col>
					<Col style={cardValue}> {item?.city} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Client name</Col>
					<Col style={cardValue}> {item?.client_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Vendor name</Col>
					<Col style={cardValue}> {item?.vendor_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Vehicle Info </Col>
					<Col style={cardValue}>
						<Box style={{ lineHeight: '2' }}>
							<Text overFlow="hidden" style={{ fontSize: '12px' }}>
								{item?.vehicle_type}
							</Text>
							<Text overFlow="hidden" style={{ color: '#787272' }}>
								{item?.vehicle_number}
							</Text>
						</Box>
					</Col>{' '}
				</Box>
				<Box style={padding135}>
					{' '}
					<Col style={cardHeader}> Start | End </Col>
					<Col style={cardValueData}>
						{' '}
						<Flex>
							{' '}
							<Box style={wid5}>
								<Text overFlow="hidden" style={{ fontSize: '12px' }}>
									{getLocalDate(item?.start_time)}
								</Text>

								<Text overFlow="hidden" style={{ color: '#787272' }}>
									{getLocalTime(item?.start_time)}
								</Text>
							</Box>
							<Box style={wid5}>
								<Text overFlow="hidden" style={{ fontSize: '12px' }}>
									{getLocalDate(item?.end_time)}
								</Text>

								<Text overFlow="hidden" style={{ color: '#787272' }}>
									{getLocalTime(item?.end_time)}
								</Text>
							</Box>
						</Flex>
					</Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}>Created By </Col>
					<Col style={cardValue}> {item?.created_by_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Driver Name </Col>
					<Col style={cardValue}> {item?.info?.driver_name} </Col>{' '}
				</Box>
				<Box style={padding35}>
					{' '}
					<Col style={cardHeader}> Trip ID </Col>
					<Col style={cardValue}>
						{' '}
						<Box style={tripID}> {item?.id} </Box>
					</Col>{' '}
				</Box>
				<Box style={viewApproved}>
					<Flex>
						<Box style={eyeStyle} onClick={() => onNavigate(item?.id)}>
							<SVG.EyeIconSVG style={{ cursor: 'pointer' }} />
						</Box>{' '}
						<Box>
							<Flex>
								<SVG.RejectIConsAPp />
								<span style={approvedS}>Rejected</span>{' '}
							</Flex>
							<Box style={approvedWith}>
								<span style={{ fontSize: '16px' }}>{item?.audited_by_name} </span>
								<br />
								<Text overFlow="hidden" style={audited_at_date}>
									{getLocalDate(item?.audited_at)}{' '}
									<span style={{ marginLeft: '8px' }}>
										{' '}
										{getLocalTime(item?.audited_at)}{' '}
									</span>
								</Text>
							</Box>

							<Text overFlow="hidden"></Text>
						</Box>
					</Flex>
				</Box>
			</Flex>
			{item?.audit_remarks && (
				<Box>
					<Box style={remarkExtra}>
						<SVG.MessageIConsAPp style={iconInline} />{' '}
						<span style={overlaps}>
							{' '}
							Reject Reason : <span style={overlaps}> {item?.audit_remarks} </span>
						</span>
					</Box>
				</Box>
			)}
			<br />
			<Box>
				<Box style={extra} onClick={() => downloadFile(item?.info?.requirement_proof)}>
					<SVG.MessageIConsAPp style={iconInline} />{' '}
					<span> Extra Requirement : Attachment Available</span>
				</Box>
			</Box>
		</Box>
	);

	const overlaps = {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	};
	const approvedWith = {
		width: '130px',
	};

	const viewApproved = {
		marginLeft: '70px',
	};

	const eyeStyle = {
		margin: '22px 9px',
		padding: '5px',
		cursor: 'pointer',
	};

	const audited_at_date = {
		fontSize: '12px',
	};
	function onNavigate(id) {
		window.location.href = `${window.origin}/trips/${id}`;
	}

	const iconInline = { display: 'inline' };

	function downloadFile(files) {
		const data = {
			url_type: 'download',
			data: {
				entity: 'trip',
				keys: files,
			},
		};

		dispatch(getSignedUrl(data)).then((res) => {
			console.log(res);
			window.open(res?.data[0]?.url);
		});
	}

	const extra = {
		fontSize: '15px',
		background: '#7ae27a',
		padding: '8px 22px',
		cursor: 'pointer',
		display: 'flex',
	};

	const remarkExtra = {
		fontSize: '15px',
		background: '#7ae2d4',
		padding: '8px 22px',
		cursor: 'pointer',
		display: 'flex',
	};

	const approvedS = {
		color: 'red',
		fontSize: '14px',
	};
	function getLenght() {
		const tot = total_count - DataSource.length;
		return tot > 0;
	}

	// const getProfiles = (item) => getTripCard(item);
	console.log(total_count);
	console.log(DataSource);
	console.log(getLenght());

	const leftShift = {
		float: 'right',
	};
	const boxmodal = {
		width: '100%',
		height: '50px',
		padding: '10px',
	};

	const { Search } = Input;

	const LtSearchBar = styled(Search)`
		border: none;
	`;

	const [searchVal, SetsearchVal] = useState(undefined);

	console.log(searchVal);

	function SetFun(e) {
		SetsearchVal(e.target.value);
	}

	function searchApproval(val) {
		SetsearchVal(val);
		if (val) {
			dispatch(getapprovalList({ limit, trip_approval_status: 3, query_str: val })).then(
				(res) => {
					console.log(res);
					SetDataSource(res?.rows);
					SetTotalCount(res?.count);
				}
			);
		} else {
			dispatch(getapprovalList({ limit, trip_approval_status: 3 })).then((res) => {
				console.log(res);
				SetDataSource(res?.rows);
				SetTotalCount(res?.count);
			});
		}
	}

	return (
		<Box>
			<Box>
				<Flex justifyContent="space-between" mt={3}>
					<Box flex="0 0 20%" marginRight="10px">
						<LtSearchBar
							placeholder="Search"
							enterButton="Search"
							value={searchVal}
							autoFocus
							allowClear
							onChange={(val) => SetFun(val)}
							onSearch={(val) => searchApproval(val)}
						/>
					</Box>

					<Flex></Flex>
					<Box style={boxmodal}>
						<Box style={leftShift}>Total Items: {DataSource.length}</Box>
					</Box>
				</Flex>
			</Box>
			<Box>
				<div
					style={{
						overflow: 'auto',
					}}
				>
					{/* <InfiniteScroll dataLength={100} next={fetchMoreData} hasMore>
						{DataSource.map((item, index) =>
							// eslint-disable-next-line react/jsx-key
							getTripCard(item, index)
						)}
					</InfiniteScroll> */}
					{DataSource.length > 0 && (
						<Box>
							{' '}
							{DataSource.map((item, index) =>
								// eslint-disable-next-line react/jsx-key
								getTripCard(item, index)
							)}{' '}
						</Box>
					)}
					{DataSource.length === 0 && (
						<Box style={{ textAlign: 'center' }}>
							{' '}
							<Text style={{ color: '#8a3a3', fontSize: '18px' }}> No Data</Text>
						</Box>
					)}
				</div>
				{DataSource.length > 0 && (
					<div style={loadMore}>
						{getLenght && (
							<Button
								onClick={fetchMoreData}
								borderRadius="4px"
								backgroundColor="#18405d"
							>
								Load More ( Next 10 items )
							</Button>
						)}
					</div>
				)}
			</Box>
		</Box>
	);
}

RejectedTrips.propTypes = {};
